import 'antd/dist/antd.min.css';
import debounce from 'lodash.debounce';
import React, { Component } from 'react';

import s from './App.module.scss';
import movieDB from './assets/js/apiModule';
import Error from './components/Error/Error';
import { GenreProvider } from './components/GenreContext/GenreContext';
import MovieMenu from './components/MovieMenu/MovieMenu';

class App extends Component {
	movieService = new movieDB();

	state = {
		guestId: '',
		genreIds: [],
		filmsData: [],
		ratedMovies: [],
		searchQuery: false,
		searchValue: '',
		loader: true,
		error: false,
		totalItems: 0,
		currentPage: 1,
		currentRatedPage: 1,
		totalRatedItems: 0,
		mobile: false,
	};

	onScreenChange = (e) => {
		if (e.target.innerWidth < 550) {
			this.setState({
				mobile: true,
			});
		} else if (e.target.innerWidth > 550) {
			this.setState({
				mobile: false,
			});
		}
	};

	onSearchChange = debounce((text) => {
		this.setState({
			loader: true,
			searchQuery: true,
			searchValue: text,
		});
		this.searchMovie(text);
	}, 500);

	componentDidMount() {
		this.fetchMovies();
		this.fetchGenreIds();
		if (localStorage.getItem('guest_session_id')) {
			this.setState({
				guestId: localStorage.getItem('guest_session_id'),
			});
		} else {
			this.createGuestSession();
		}
		if (window.screen.width === 420) {
			this.setState({
				mobile: true,
			});
		}
		window.addEventListener('resize', this.onScreenChange);
	}

	componentWillUnmount() {
		window.removeEventListener(this.onScreenChange);
	}

	onError() {
		this.setState({
			error: true,
		});
	}

	onErrorClose = () => {
		this.setState({
			error: false,
		});
		this.fetchMovies();
	};

	onPageChange = (page) => {
		this.setState({
			loader: true,
		});
		this.state.searchQuery ? this.searchMovie(this.state.searchValue, page) : this.fetchMovies(page);
	};

	onRatePageChange = (page) => {
		this.setState({
			loader: true,
		});
		this.fetchRatedMovies(page);
	};

	async fetchMovies(page) {
		try {
			const result = await this.movieService.getPopularMovies(page);
			return this.onMovieLoad(result);
		} catch (error) {
			this.onError();
		}
	}

	async fetchRatedMovies(page) {
		try {
			const result = await this.movieService.getRatedFilms(this.state.guestId, page);
			return this.onRatingMovieLoad(result);
		} catch (error) {
			this.onError();
		}
	}

	async fetchGenreIds() {
		try {
			const result = await this.movieService.getGenreList();
			this.setState({
				genreIds: result.genres,
			});
		} catch {
			this.onError();
		}
	}

	createGuestSession = async () => {
		const result = await this.movieService.createGuestSession();
		if (result.success === true) {
			localStorage.setItem('guest_session_id', result.guest_session_id);
			this.setState({
				guestId: result.guest_session_id,
			});
		} else {
			this.onError();
		}
	};

	onMovieLoad({ results, page, total_pages }) {
		this.setState({
			filmsData: results,
			loader: false,
			currentPage: page,
			totalItems: total_pages,
		});
	}

	onRatingMovieLoad({ results, page, total_results }) {
		this.setState({
			ratedMovies: results,
			loader: false,
			currentRatedPage: page,
			totalRatedItems: total_results,
		});
	}

	onTabChange = async (key) => {
		if (Number(key) === 2) {
			this.setState({
				loader: true,
			});
			this.fetchRatedMovies();
		}
	};

	searchMovie = async (query, page) => {
		try {
			if (query) {
				let result = await this.movieService.searchMovies(query, page);
				return this.onMovieLoad(result);
			} else {
				this.setState({
					searchValue: '',
					searchQuery: false,
				});
				this.fetchMovies();
			}
		} catch (err) {
			console.log(err);
		}
	};

	render() {
		const { error } = this.state;

		const contentPage = error ? (
			<Error status="error" text="Something bad happened, our team is working on this problem" onErrorClose={this.onErrorClose} close={false} />
		) : (
			<Content
				state={this.state}
				onSearchChange={this.onSearchChange}
				onPageChange={this.onPageChange}
				addRatedMovie={this.addRatedMovie}
				onTabChange={this.onTabChange}
				onRatePageChange={this.onRatePageChange}
			/>
		);

		return (
			<GenreProvider value={this.state.genreIds}>
				<div className={error ? `${s.app} ${s.error}` : s.app}>{contentPage}</div>
			</GenreProvider>
		);
	}
}

const Content = ({ state, onSearchChange, onPageChange, onTabChange, onRatePageChange }) => {
	const { filmsData, loader, currentPage, totalItems, searchQuery, ratedMovies, currentRatedPage, totalRatedItems, mobile } = state;

	return (
		<React.Fragment>
			<div className="App__container">
				<MovieMenu
					movies={filmsData}
					ratedMovies={ratedMovies}
					onSearchChange={onSearchChange}
					loader={loader}
					currentPage={currentPage}
					currentRatedPage={currentRatedPage}
					totalItems={totalItems}
					totalRatedItems={totalRatedItems}
					onPageChange={onPageChange}
					onRatePageChange={onRatePageChange}
					searchQuery={searchQuery}
					onTabChange={onTabChange}
					mobile={mobile}
				/>
			</div>
		</React.Fragment>
	);
};

export default App;
